import { getTableColumns } from 'helpers';

const SplReqColumns = [
  ['registrationType', 'string', 'Registration Type', 'left', true],
  ['rosterOwner', 'string', 'Roster Owner', 'left', true],
  ['irbType', 'string', 'IRB Type', 'left', true],
  ['countryCode', 'string', 'Country', 'left', true],
  ['siteCtepId', 'string', 'CTEP ID', 'left', true]
];


export default getTableColumns(SplReqColumns);
